<template>
  <div class="culture">
    <div class="banner">
      <el-input
        placeholder="请输入搜索内容"
        suffix-icon="el-icon-search"
        v-model="search"
        style="
          position: absolute;
          right: 13.54vw;
          top: 1.04vw;
          width: 9.38vw;
          height: 1.67vw;
        "
        @focus="turnto('/search', search)"
      >
      </el-input>
    </div>
    <div class="culturecontent">
      <div class="navs">
        <navlist :navlist="navlist" @returnpath="returnpath" />
      </div>
      <div class="miancontent">
        <newsallVue v-if="navindex == 0" />
        <newsdynamicVue v-if="navindex == 1" />
      </div>
    </div>
  </div>
</template>

<script>
import navlist from "./commonnavs.vue";
import newsallVue from "./newsall.vue";
import newsdynamicVue from "./newsdynamic.vue";
export default {
  components: { navlist, newsallVue, newsdynamicVue },
  data() {
    return {
      search: "",
      navlist: {
        name: "新闻中心",
        list: [
          { name: "综合新闻", index: 0 },
          { name: "工程动态", index: 1 },
        ],
      },
      navindex: 0,
      issend: 0,
    };
  },
  methods: {
    turnto(path, data) {
      this.$router.push({
        path,
      });
    },
    returnpath(e) {
      this.navindex = e;
    },
  },
  watch: {
    $route(to, from) {
      if (to.query.index) {
        this.navindex = to.query.index;
      }
    },
  },
};
</script>

<style scoped lang="less">
.culture {
  .culturecontent {
    .miancontent {
      flex: 1;
    }
    .navs {
      width: 10.42vw;
      height: 21.88vw;
      margin-right: 1.25vw;
    }
    width: 100%;
    padding: 1.56vw 13.54vw 5.21vw 13.54vw;
    display: flex;
  }
  .banner {
    position: relative;
    width: 100%;
    height: 26.04vw;
    //background: url("https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/banner/bannernewstop.png") no-repeat;
    background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/bannernewstop.png") no-repeat;
    background-position: 0 0;
    background-size: 100%;
  }
  width: 100%;
  background: rgba(240, 242, 246, 1);
  position: relative;
}
.el-icon-search:before {
  color: #06192d !important;
}
</style>
